import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { conversationHistory } from "./constants";
import type {
  ConversationHistoryListResult,
  ConversationHistorySummary,
  ConversationHistoryTableParams,
} from "./types";
import { isConversationHistoryListResult } from "./validators";

export const getDataTableConversationHistory = reactQueryTableFetcherAdapter<
  typeof conversationHistory,
  ConversationHistoryTableParams,
  ConversationHistorySummary,
  ConversationHistoryListResult
>(
  conversationHistory,
  (
    signal: AbortSignal,
    { appGroupId, historyType, limit = 12, start = 0 }: ConversationHistoryTableParams
  ): Promise<ConversationHistoryListResult> => {
    return fetch(`/${appGroupId}/conversational/conversations/${historyType}`, "GET", { limit, start }, { signal });
  },
  isConversationHistoryListResult
);
